import { User } from "phosphor-react";
import React from "react";
import "../../styles/components/buyerRanking.module.scss";

const RifaBuyerRanking = ({buyerRanking, ...props}) => {
    const positions = [
        {icon: "trophy_gold.svg", positionLabel: "primeiro lugar", color: "#FFBA57"},
        {icon: "trophy_silver.svg", positionLabel: "segundo lugar", color: "#898989"},
        {icon: "trophy_bronze.svg", positionLabel: "terceiro lugar", color: "#CE7430"}
      ];
    
    return buyerRanking.length ? <React.Fragment>
        <div className={"buyer-ranking-card"} {...props}>
            <h6>🏆 Maiores compradores</h6>
            {/* <p className={"ranking-subtitle"}>Os 3 maiores compradores da rifa ganham <strong className={"red"} style={{whiteSpace: "nowrap"}}>R$ 500,00</strong></p> */}
            <div className="ranking-grid">{buyerRanking.slice(0,3).map((item, i) => {
                return (<div className="buyer-ranking-item">
                    <span className="ranking-trophy">
                        <img src={`/assets/icons/${positions[i].icon}`} height={"100%"} width={"auto"} style={{marginRight: "4px"}}/>
                    </span>
                    
                    <div className="ranking-content">
                        <strong>{item.name}</strong>
                    </div>
                </div>)
            })}
            </div>
    </div>
    </React.Fragment> : null
}

export {RifaBuyerRanking}


// WEBPACK FOOTER //
// ./src/rifa/components/layout/buyerRanking.jsx